// extracted by mini-css-extract-plugin
export default {"gradient_button":"GradientButton_gradient_button__G7Eu1"};